export default __webpack_public_path__ + "static/White-Background-Tile-2x-16c37b50592fa0135e9a704821142fec.webp";